import { createContext } from 'react';
import { ICriteriaOptionItem } from '~/common/types';

export type IFormContext = {
  criteria: { optionItems: Array<ICriteriaOptionItem> };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
